export const enum SPEAKER {
    CHRIS_BROAD = 'chrisbroad',
    CONNOR = 'connor',
    GARNT = 'garnt',
    JOE = 'joe',
    MEILYNE = 'meilyne',
    MORICALLIOPE = 'mori-calliope',
    NORIYARO = 'noriyaro',
    SHIBUYAKAHO = 'shibuya-kaho',
    SYDSNAP = 'sydsnap',
    REVIEW = 'review',
}

export const enum SPEAKER_SHORT {
    CONNOR = 'c',
    GARNT = 'g',
    JOE = 'j',
};

export type T_SpeakerList = {
    [key in SPEAKER]: {
        id: SPEAKER,
        label: string,
        hotkey?: string
    }
};

export const SPEAKER_LIST: T_SpeakerList= {
    [SPEAKER.CHRIS_BROAD]: {
        id: SPEAKER.CHRIS_BROAD,
        label: 'Chris broad',
    },

    [SPEAKER.CONNOR]: {
        id: SPEAKER.CONNOR,
        label: 'Connor',
        hotkey: 'c',
    },

    [SPEAKER.GARNT]: {
        id: SPEAKER.GARNT,
        label: 'Garnt',
        hotkey: 'v',
    },

    [SPEAKER.JOE]: {
        id: SPEAKER.JOE,
        label: 'Joe',
        hotkey: 'b',
    },

    [SPEAKER.MEILYNE]: {
        id: SPEAKER.MEILYNE,
        label: 'Meilyne',
    },

    [SPEAKER.MORICALLIOPE]: {
        id: SPEAKER.MORICALLIOPE,
        label: 'Mori Calliope',
    },

    [SPEAKER.NORIYARO]: {
        id: SPEAKER.NORIYARO,
        label: 'Noriyaro',
    },

    [SPEAKER.SHIBUYAKAHO]: {
        id: SPEAKER.SHIBUYAKAHO,
        label: 'Shibuya Kaho',
    },

    [SPEAKER.SYDSNAP]: {
        id: SPEAKER.SYDSNAP,
        label: 'Sydsnap',
    },

    [SPEAKER.REVIEW]: {
        id: SPEAKER.REVIEW,
        label: 'Review',
        hotkey: 'x',
    },
}

export function isSpeakerHost(speaker: SPEAKER): boolean {
    if (speaker === SPEAKER.JOE ||
        speaker === SPEAKER.GARNT ||
        speaker === SPEAKER.CONNOR
    ) {
        return true;
    }

    return false;
}

export function isSpeakerHost_short(speaker: SPEAKER_SHORT): boolean {
    if (speaker === SPEAKER_SHORT.JOE ||
        speaker === SPEAKER_SHORT.GARNT ||
        speaker === SPEAKER_SHORT.CONNOR
    ) {
        return true;
    }

    return false;
}
